module Tapas.Bindings {
    export class FormSubmitOnChange {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

			var load = bindingContext.$root.load();
			var timeout;
			
			var text = valueAccessor().text;
			var delay = valueAccessor().delay;
           

            $(element).on("change", function () {
				if (!delay) {
					load.active(true);
					load.text(text);
					$(element).submit();
				}
				else {
					clearTimeout(timeout);

					timeout = setTimeout(function () {
						load.active(true);
						load.text(text);

						$(element).submit();
					}, delay);
				}
			});

			$(window).unload(function () {
				load.active(false);
			});
        }
    }
    ko.bindingHandlers['formSubmitOnChange'] = new FormSubmitOnChange();
}